import b from "../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import M from "../../@babel/runtime/helpers/esm/defineProperty2.mjs";
import D from "../../@babel/runtime/helpers/esm/classCallCheck2.mjs";
import H from "../../@babel/runtime/helpers/esm/createClass2.mjs";
import L from "../../@babel/runtime/helpers/esm/inherits2.mjs";
import _ from "../../@babel/runtime/helpers/esm/createSuper2.mjs";
import * as u from "react";
import S from "../../classnames/index.mjs";
import m from "../../rc-util/es/raf.mjs";
var y = 20;
function R(s) {
  return "touches" in s ? s.touches[0].pageY : s.pageY;
}
var N = /* @__PURE__ */ function(s) {
  L(l, s);
  var f = _(l);
  function l() {
    var e;
    D(this, l);
    for (var i = arguments.length, c = new Array(i), a = 0; a < i; a++)
      c[a] = arguments[a];
    return e = f.call.apply(f, [this].concat(c)), e.moveRaf = null, e.scrollbarRef = /* @__PURE__ */ u.createRef(), e.thumbRef = /* @__PURE__ */ u.createRef(), e.visibleTimeout = null, e.state = {
      dragging: !1,
      pageY: null,
      startTop: null,
      visible: !1
    }, e.delayHidden = function() {
      clearTimeout(e.visibleTimeout), e.setState({
        visible: !0
      }), e.visibleTimeout = setTimeout(function() {
        e.setState({
          visible: !1
        });
      }, 2e3);
    }, e.onScrollbarTouchStart = function(t) {
      t.preventDefault();
    }, e.onContainerMouseDown = function(t) {
      t.stopPropagation(), t.preventDefault();
    }, e.patchEvents = function() {
      window.addEventListener("mousemove", e.onMouseMove), window.addEventListener("mouseup", e.onMouseUp), e.thumbRef.current.addEventListener("touchmove", e.onMouseMove), e.thumbRef.current.addEventListener("touchend", e.onMouseUp);
    }, e.removeEvents = function() {
      var t;
      window.removeEventListener("mousemove", e.onMouseMove), window.removeEventListener("mouseup", e.onMouseUp), (t = e.scrollbarRef.current) === null || t === void 0 || t.removeEventListener("touchstart", e.onScrollbarTouchStart), e.thumbRef.current && (e.thumbRef.current.removeEventListener("touchstart", e.onMouseDown), e.thumbRef.current.removeEventListener("touchmove", e.onMouseMove), e.thumbRef.current.removeEventListener("touchend", e.onMouseUp)), m.cancel(e.moveRaf);
    }, e.onMouseDown = function(t) {
      var o = e.props.onStartMove;
      e.setState({
        dragging: !0,
        pageY: R(t),
        startTop: e.getTop()
      }), o(), e.patchEvents(), t.stopPropagation(), t.preventDefault();
    }, e.onMouseMove = function(t) {
      var o = e.state, r = o.dragging, n = o.pageY, h = o.startTop, p = e.props.onScroll;
      if (m.cancel(e.moveRaf), r) {
        var v = R(t) - n, g = h + v, E = e.getEnableScrollRange(), d = e.getEnableHeightRange(), w = d ? g / d : 0, T = Math.ceil(w * E);
        e.moveRaf = m(function() {
          p(T);
        });
      }
    }, e.onMouseUp = function() {
      var t = e.props.onStopMove;
      e.setState({
        dragging: !1
      }), t(), e.removeEvents();
    }, e.getSpinHeight = function() {
      var t = e.props, o = t.height, r = t.count, n = o / r * 10;
      return n = Math.max(n, y), n = Math.min(n, o / 2), Math.floor(n);
    }, e.getEnableScrollRange = function() {
      var t = e.props, o = t.scrollHeight, r = t.height;
      return o - r || 0;
    }, e.getEnableHeightRange = function() {
      var t = e.props.height, o = e.getSpinHeight();
      return t - o || 0;
    }, e.getTop = function() {
      var t = e.props.scrollTop, o = e.getEnableScrollRange(), r = e.getEnableHeightRange();
      if (t === 0 || o === 0)
        return 0;
      var n = t / o;
      return n * r;
    }, e.showScroll = function() {
      var t = e.props, o = t.height, r = t.scrollHeight;
      return r > o;
    }, e;
  }
  return H(l, [{
    key: "componentDidMount",
    value: function() {
      this.scrollbarRef.current.addEventListener("touchstart", this.onScrollbarTouchStart), this.thumbRef.current.addEventListener("touchstart", this.onMouseDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      i.scrollTop !== this.props.scrollTop && this.delayHidden();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.removeEvents(), clearTimeout(this.visibleTimeout);
    }
  }, {
    key: "render",
    value: (
      // ====================== Render =======================
      function() {
        var i = this.state, c = i.dragging, a = i.visible, t = this.props, o = t.prefixCls, r = t.direction, n = this.getSpinHeight(), h = this.getTop(), p = this.showScroll(), v = p && a, g = r === "rtl" ? {
          left: 0
        } : {
          right: 0
        };
        return /* @__PURE__ */ u.createElement("div", {
          ref: this.scrollbarRef,
          className: S("".concat(o, "-scrollbar"), M({}, "".concat(o, "-scrollbar-show"), p)),
          style: b(b({
            width: 8,
            top: 0,
            bottom: 0
          }, g), {}, {
            position: "absolute",
            display: v ? null : "none"
          }),
          onMouseDown: this.onContainerMouseDown,
          onMouseMove: this.delayHidden
        }, /* @__PURE__ */ u.createElement("div", {
          ref: this.thumbRef,
          className: S("".concat(o, "-scrollbar-thumb"), M({}, "".concat(o, "-scrollbar-thumb-moving"), c)),
          style: {
            width: "100%",
            height: n,
            top: h,
            left: 0,
            position: "absolute",
            background: "rgba(0, 0, 0, 0.5)",
            borderRadius: 99,
            cursor: "pointer",
            userSelect: "none"
          },
          onMouseDown: this.onMouseDown
        }));
      }
    )
  }]), l;
}(u.Component);
export {
  N as default
};
//# sourceMappingURL=ScrollBar.mjs.map
